import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { GALLERY_SINGLES, GALLERY_OWN, GALLERY_FILTERS } from "../data";

export default function Gallery() {
  const [filter, setFilter] = useState("all");

  const showSingle = (s) => filter === "all" || s.category === filter;
  const singles = [...GALLERY_OWN.map((s) => ({ ...s, own: true })), ...GALLERY_SINGLES].filter(showSingle);

  return (
    <div data-testid="gallery-page" className="pt-20">
      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pt-16 pb-10">
        <Reveal>
          <Overline>Project gallery</Overline>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-slate-100 tracking-tight leading-[1.1] max-w-3xl">
            Proof over <span className="text-gold-gradient">promises</span>
          </h1>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-slate-400 leading-relaxed">
            Real GlowMode installs and standout work across Salt Lake County — the glow that made the neighbors jealous.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div data-testid="gallery-filters" className="mt-10 flex flex-wrap gap-2.5">
            {GALLERY_FILTERS.map((f) => (
              <button
                key={f.id}
                data-testid={`gallery-filter-${f.id}`}
                onClick={() => setFilter(f.id)}
                className={`px-4 py-2 rounded-full text-sm font-medium border transition-all duration-200 ${
                  filter === f.id
                    ? "border-gold text-obsidian bg-gradient-to-br from-gold-light via-gold to-gold-dark font-semibold"
                    : "border-white/10 text-slate-300 hover:border-gold/40 hover:-translate-y-0.5"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pb-20">
        <div data-testid="gallery-singles-grid" className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {singles.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 0.08}>
              <div
                data-testid={`gallery-card-${s.id}`}
                className="group relative h-72 overflow-hidden rounded-2xl border border-gold/25 shadow-[0_0_16px_rgba(233,199,103,0.10)] transition-all duration-300 hover:border-gold/60 hover:shadow-[0_0_30px_rgba(233,199,103,0.30)] hover:-translate-y-1"
              >
                <img src={s.url} alt={s.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-transparent to-transparent" />
                {s.own && (
                  <span className="absolute top-4 left-4 px-3 py-1 rounded-full text-[10px] font-mono uppercase tracking-[0.2em] text-obsidian font-semibold bg-gradient-to-br from-gold-light via-gold to-gold-dark">
                    GlowMode Install
                  </span>
                )}
                <p className="absolute bottom-4 left-4 right-4 font-serif text-lg text-slate-100">{s.title}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-t border-white/5 bg-charcoal/40">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 text-center">
          <Reveal>
            <h2 className="text-2xl sm:text-3xl font-serif font-semibold text-slate-100 mb-6">
              Your property could be the next transformation
            </h2>
            <Link
              to="/book"
              data-testid="gallery-book-button"
              className="group inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-obsidian bg-gradient-to-br from-gold-light via-gold to-gold-dark transition-all duration-300 hover:shadow-[0_0_35px_rgba(233,199,103,0.5)] hover:-translate-y-0.5"
            >
              Book Your Free Quote
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
